import GlobalProvider from '@/app/providers/GlobalProvider';
import AppRouter from '@/app/router/AppRouter';

const App = () => {
  return (
    <GlobalProvider locale="en" theme="light">
      <AppRouter />
    </GlobalProvider>
  );
};

export default App;
